import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  addNotification,
  closeBudget,
  pushModal,
  signOut,
} from 'loot-core/client/actions';

import { useAuth } from '../../../hooks/useAuth';
import { useLocalPref } from '../../../hooks/useLocalPref';
import { useNavigate } from '../../../hooks/useNavigate';
import { SvgExpandArrow } from '../../../icons/v0';
import { useResponsive } from '../../../ResponsiveProvider';
import { theme } from '../../../style';
import { SyncButton } from '../../Titlebar';
import { Tooltip } from '../../tooltips';
import { Button } from '../Button';
import { RenameBudget } from '../EditableBudgetName';
import { Menu } from '../Menu';
import { Text } from '../Text';

export function ProfileDropdown() {
  const [budgetName] = useLocalPref('budgetName');

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isAuthenticated, hasRemoteAccount, refreshAuthState } = useAuth();
  const username = useSelector(state => state.auth.username);
  const { isNarrowWidth } = useResponsive();
  const [menuOpen, setMenuOpen] = useState(false);

  async function onMenuSelect(type: string) {
    setMenuOpen(false);

    switch (type) {
      case 'my-profile':
        navigate('/my-profile');
        break;
      case 'change-password':
        navigate('/change-password');
        break;
      case 'billing':
        navigate('/billing');
        break;
      case 'logout':
        await dispatch(signOut());
        await dispatch(closeBudget());
        await refreshAuthState();
        break;
      case 'close_file':
        await dispatch(closeBudget());
        break;
      default:
    }
  }

  function onLogin() {
    dispatch(pushModal('hybrid-auth', { type: 'login' }));
  }

  function onSignup() {
    dispatch(pushModal('hybrid-auth', { type: 'signup' }));
  }

  const items: any = [
    { name: 'username', text: 'Hi ' + username, unclickable: true },
    Menu.line,
    { name: 'my-profile', text: 'My profile' },
    { name: 'change-password', text: 'Change password' },
    { name: 'billing', text: 'Billing' },
    isAuthenticated && { name: 'logout', text: 'Logout' },
    ...(isNarrowWidth
      ? [
          Menu.line,
          {
            name: 'budgetName',
            text: (
              <p
                style={{
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  maxWidth: 180,
                  margin: 0,
                }}
              >
                <b>{budgetName}</b>
              </p>
            ),
            unclickable: true,
          },
          { name: 'sync', text: <SyncButton style={{ padding: 0 }} /> },
          { name: 'rename_budget', text: <RenameBudget /> },
          { name: 'close_file', text: 'Close file' },
        ]
      : []),
  ];

  if (!isAuthenticated) {
    if (hasRemoteAccount) {
      return (
        <Button
          type="primary"
          style={{
            cursor: 'pointer',
          }}
          onClick={onLogin}
        >
          Sign-in
        </Button>
      );
    } else {
      return (
        <Button
          type="primary"
          style={{
            cursor: 'pointer',
          }}
          onClick={onSignup}
        >
          Signup
        </Button>
      );
    }
  }

  return (
    <Button
      type="bare"
      color={theme.buttonNormalBorder}
      style={{
        fontSize: 16,
        fontWeight: 500,
        marginLeft: -5,
        flex: '0 auto',
      }}
      onClick={() => setMenuOpen(true)}
    >
      <Text style={{ whiteSpace: 'nowrap', overflow: 'hidden' }}>
        {username}
      </Text>
      <SvgExpandArrow width={7} height={7} style={{ marginLeft: 5 }} />
      {menuOpen && (
        <Tooltip
          position="bottom-right"
          style={{ padding: 0, minWidth: 150 }}
          onClose={() => setMenuOpen(false)}
        >
          <Menu onMenuSelect={onMenuSelect} items={items} />
        </Tooltip>
      )}
    </Button>
  );
}
